<template>
  <v-dialog v-model="isActive" @keydown.esc="isActive = false" :max-width="maxWidth" scrollable>
    <v-card>

      <v-card-title class="title">
        <slot name="title">
          <span class="mr-5">{{ title }}</span>
        </slot>
        <v-btn icon @click="close" right absolute class="mr-2">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container :style="{ marginLeft: disableAutoMargin ? '0' : 'auto' }" grid-list-lg>
          <v-layout wrap row justify-space-between class="subheading">
            <slot />
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'

export default {
  name: 'InfoDialog',
  mixins: [Toggleable],
  props: {
    title: String,
    maxWidth: {
      type: String,
      default: '700px'
    },
    disableAutoMargin: {
      type: Boolean,
      default: false
    },
    height: String,
    onClose: {
      type: Function,
      default: () => { }
    }
  },
  methods: {
    show() {
      this.isActive = true;
    },
    close(){
      this.onClose();
      this.isActive = false;
    }
  }
}
</script>